import { Box, Grid, Theme, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { servicePreferenceMasterData } from '../../redux-store/actions';
import { ApplicationProps, servicePreferencesMasterType } from '../../redux-store/types/api-types';
import { updatedServicePreference } from '../investors/servicePreferenceDetails';
import { Gridstyles } from './index';
import { KeyValue } from './personalDetails';

export default function ServicePreference({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { servicepreferences = [] } = application || {};
  const [servicePreferenceData, setServicePreferenceData] = useState<updatedServicePreference[]>(
    []
  );
  const dispatch = useDispatch();

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(
          servicePreferenceMasterData()
        )) as unknown as servicePreferencesMasterType;
        setServicePreferenceData(
          response.servicePreference
            ?.map((mdmsService) => {
              const existingServicePreference = servicepreferences?.filter(
                (preference) => preference.question === mdmsService.key
              );

              return existingServicePreference?.map((existingPreferences) => {
                const checkAnswer = mdmsService.values
                  ?.map((value) => {
                    if (value.key === existingPreferences.answer) {
                      return value.label;
                    }
                    return;
                  })
                  ?.filter((ele) => ele);
                return {
                  ...existingPreferences,
                  ...mdmsService,
                  answer: checkAnswer?.toString() || existingPreferences.answer,
                };
              });
            })
            .flat() as unknown as updatedServicePreference[]
        );
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: theme.palette.customColors.infoCard,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}>
        <Box >
          <Grid container >
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
              Service Preference
            </Typography>
            <React.Fragment>
              <Box sx={{ width: '100%' }}>
                {/* <Gridstyles> */}
                <Grid
                  item
                  container
                  // pb={5}
                  rowSpacing={3}
                  columnSpacing={5.5}
                  direction="row"
                // justifyContent="space-between"
                // alignItems="flex-start"
                >
                  {servicePreferenceData.length ? (
                    <>
                      {servicePreferenceData?.map((preferenceData) => {
                        return (
                          <React.Fragment key={preferenceData?.id}>
                            {preferenceData.isMultiselect === 'false' && (
                              <KeyValue
                                title={preferenceData.sectionHeading}
                                description={preferenceData.answer}
                              />
                            )}
                          </React.Fragment>
                        );
                      })}
                    </>
                  ) : (
                    <Grid
                      xs={12}
                      sm={12}
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'common.black',
                        textAlign: 'center',
                        my: 3,
                      }}>
                      No Service Preference
                    </Grid>
                  )}
                </Grid>
                {/* </Gridstyles> */}
              </Box>
            </React.Fragment>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
